import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Callout from '@/components/Callout';
import FragmentLink from '@/components/FragmentLink';

// Components handed to MDXProvider for every content page. Authors get
// <Callout> without importing it (CONTENT-SPEC §2); site-relative links use
// the router; tables get a horizontal scroll container on narrow screens.

const A = ({ href = '', children, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement>) => {
  if (href.startsWith('#')) return <FragmentLink hash={href} {...rest}>{children}</FragmentLink>;
  if (href.startsWith('/')) {
    return (
      <Link to={href} {...(rest as object)}>
        {children}
      </Link>
    );
  }
  const external = /^https?:\/\//.test(href);
  return (
    <a href={href} {...rest} {...(external ? { rel: 'noopener', target: '_blank' } : {})}>
      {children}
    </a>
  );
};

const Table = ({ children }: { children?: ReactNode }) => (
  <div className="not-prose my-8 overflow-x-auto">
    <table className="w-full border-collapse text-[1.0625rem] leading-[1.45] [&_td]:border-b [&_td]:border-rule [&_td]:px-3 [&_td]:py-2.5 [&_td]:align-top [&_th]:border-b-2 [&_th]:border-forest [&_th]:px-3 [&_th]:py-2.5 [&_th]:text-left [&_th]:font-bold">
      {children}
    </table>
  </div>
);

export const mdxComponents = {
  Callout,
  a: A,
  table: Table,
};
